import { Typography } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import { AsterChip } from 'asterX-UI/Chip'
import { getStatusColor } from 'lib/constants/deals'
import { getFormattedFiltersDate } from 'lib/utils'

export const lawHistoryColumns = ['Тип действия', 'Результат', 'Менеджер', 'Дата создания', 'Комментарий', '']

export const lawHistoryRows = list => {
  if (!list) {
    return []
  }

  const sortedLaws = list.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))

  return sortedLaws?.map(item => {
    return [
      <AsterChip label={item?.type?.name} style={getStatusColor(item?.type?.code)} />,
      item?.result ? <AsterChip label={item?.result?.name} style={getStatusColor(item?.result?.code)} /> : '-',
      item?.createdByFullName || '-',
      getFormattedFiltersDate(item?.createdDate),
      <Typography style={{ wordBreak: 'break-word', fontSize: 14 }}>{item?.description}</Typography>,
      {
        isButton: true,
        label: <ChevronRight />,
        data: { id: item?.id }
      }
    ]
  })
}
